// #71 Skeleton: placeholder blocks at the final geometry on --card-2 (DC-25: no page spinner). aria-hidden; the host
// that is loading carries aria-busy. The 200 ms shimmer is off under reduced motion and capture (00-tokens.css).

import { cx } from "../lib/cx";
import { vars } from "../lib/vars";

type Width = number | `${number}%`;

/** A px width goes to --mc-w (a number), a percentage to --mc-wp; the CSS adds the two. */
const widthVars = (w: Width | undefined) => (typeof w === "number" ? { "--mc-w": w } as const : { "--mc-wp": w ?? "100%" } as const);

export interface SkeletonProps {
  /** Width in px or a percentage (default 100%). */
  width?: Width | undefined;
  /** Height in px (default 14, a text line). */
  height?: number | undefined;
  /** Several lines of the same height, the last shorter. */
  lines?: number | undefined;
  /** tile (default) · pill (a pill or chip) · input (a button or field). */
  shape?: "tile" | "pill" | "input" | undefined;
  className?: string | undefined;
}

export function Skeleton({ width, height, lines, shape = "tile", className }: SkeletonProps) {
  const block = (key: number, w: Width | undefined) => (
    <span key={key} className={cx("mc-skel", shape !== "tile" && `mc-skel-${shape}`, className)} style={vars({ ...widthVars(w), "--mc-h": height })} />
  );
  if (lines && lines > 1) {
    return (
      <span className="mc-skel-lines" aria-hidden="true">
        {Array.from({ length: lines }, (_, index) => block(index, index === lines - 1 ? "60%" : width))}
      </span>
    );
  }
  return <span className="mc-skel-one" aria-hidden="true">{block(0, width)}</span>;
}
